import cx from 'classnames'
import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {RadioInput} from 'components/system/inputs/RadioInput'
import {lowerCase} from 'lodash'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {useCallback} from 'react'
import {Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {ga4} from 'utils/ga4'
import {getUnitPricing} from 'utils/getPricingFrom'
import {StepDataProvider} from '../../../../providers/StepDataProvider/StepDataProvider'

type Props = {
  option: Ventrata.Option
}

export const Option = ({option}: Props) => {
  const dataManager = StepDataProvider.useOptionDataManager()
  const product = VentrataDataProvider.useProduct()
  const currency = EnvironmentProvider.useCurrency()

  const onOptionSelect = useCallback(
    (optionId: string) => {
      dataManager.save(optionId)

      ga4({
        event: 'select_option',
        item_id: product.id,
        item_name: product.title,
        item_variant: option.title,
        checkout_type: 'custom_checkout',
      })
    },
    [product, option, dataManager]
  )

  return (
    <div
      className={cx(
        'p-4 rounded-lg border border-solid',
        option.id === dataManager.getData()
          ? 'border-theme'
          : 'border-[#F6F6F6] bg-[#F6F6F6] hover:opacity-80 cursor-pointer'
      )}
      onClick={() => onOptionSelect(option.id)}
    >
      <div className="flex flex-col w-full">
        <div className="flex flex-col gap-1 pb-4">
          <div className="flex justify-between">
            <div className="font-bold text-xl">{option.title}</div>
            <RadioInput checked={option.id === dataManager.getData()} className="!static" />
          </div>
          {option.shortDescription && (
            <div
              className="text-base text-text-secondary"
              dangerouslySetInnerHTML={{__html: option.shortDescription}}
            />
          )}
        </div>

        <div className="flex flex-col gap-4 py-4">
          <div className="flex justify-between">
            <div>Cost:</div>
            <div className="text-end">
              {option.units
                .map(
                  (unit) =>
                    `${formatMoney(getUnitPricing(unit, currency, 'pricingFrom')?.retail, currency)}/${lowerCase(
                      unit.title
                    )}`
                )
                .join(', ')}
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div>Duration:</div>
            <div>{option.duration}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
